import styled from 'styled-components';
import React, { FunctionComponent } from 'react';

const TooltipContainer = styled.div`
  width: 20rem;
  max-height: 5rem;
  margin-left: -10rem;
  position: absolute;
  bottom: 70%;
  left: 50%;
  z-index: 20;
  text-align: center;
  opacity: 0;
  transition: all 200ms cubic-bezier(0, 0.73, 0.24, 1.17);
  pointer-events: none;
  overflow: hidden;
  :after {
    content: '';
    display: block;
    width: 0;
    border: 8px solid transparent;
    border-bottom-width: 0;
    border-top-color: #867976;
    margin: 0 auto;
  }
  div:hover > &&,
  li:hover > && {
    bottom: 100%;
    opacity: 1;
    transition-duration: 1s;
  }
`;
const TooltipContent = styled.div`
  display: inline-block;
  padding: 0.5rem 0.625rem;
  background-color: #867976;
  color: #fff;
`;

export const Tooltip: FunctionComponent = ({ children }) => (
  <TooltipContainer data-testid="product-selection-tooltip">
    <TooltipContent>{children}</TooltipContent>
  </TooltipContainer>
);

export default Tooltip;
